import { EuiFlexGroup, EuiFlexItem, EuiSpacer } from "@elastic/eui";
import React, { useMemo, useRef } from "react";
import { Menu } from "../../../components/Menus";
import { GridResultsScreen } from "./Grid/GridResultsScreen";

export const InformacionRolesExpatriadosScreen = (props)=>{

    const {data,translate} = props;
    const refGrid = useRef();

    const onFilterClear = () => { 
        refGrid.current && refGrid.current.onFilterClear()
    }

    const onExport = () =>{
        refGrid && refGrid.current.onExport();
    }
    
    const Actions = useMemo(()=>[
        {handle:onFilterClear,text:translate('limpiar-filtro'),size:"s", isDisabled: false, className: "btnFilterClear"},
        {handle:onExport,text:translate('exportar'),size:"s", isDisabled:false},
    ],[onFilterClear])

    return(
        <>
        <EuiFlexGroup alignItems={'center'} justifyContent="flexEnd" className="filter" wrap>
          <EuiFlexItem>
                <Menu actions={Actions} className="actions"/>
          </EuiFlexItem>
        </EuiFlexGroup>
         <EuiSpacer size="m" />
         <GridResultsScreen data={data} ref={refGrid} translate={translate}/>
       </> 
      );
}